/**
 * 统一响应式断点常量
 * 所有页面的媒体查询都应使用这些常量，保持全局一致性
 *
 * 分辨率区间：
 *   mobile   :  0 ~ 767px    手机竖屏
 *   tablet   :  768 ~ 1023px 平板 / 手机横屏
 *   desktop  :  1024 ~ 1439px 普通桌面
 *   wide     :  >= 1440px     宽屏 / 大显示器
 */

export const BREAKPOINTS = {
  mobile: 767,   // <= 767 为手机
  tablet: 1023,  // 768 ~ 1023 为平板
  desktop: 1439, // 1024 ~ 1439 为普通桌面
  wide: 1440     // >= 1440 为宽屏
}

/**
 * 媒体查询字符串，可在 JS 中配合 window.matchMedia 使用
 * 示例：window.matchMedia(MEDIA_QUERIES.mobile).matches
 */
export const MEDIA_QUERIES = {
  mobile: `(max-width: ${BREAKPOINTS.mobile}px)`,
  tablet: `(min-width: ${BREAKPOINTS.mobile + 1}px) and (max-width: ${BREAKPOINTS.tablet}px)`,
  desktop: `(min-width: ${BREAKPOINTS.tablet + 1}px) and (max-width: ${BREAKPOINTS.desktop}px)`,
  wide: `(min-width: ${BREAKPOINTS.wide}px)`,
  // 常用组合
  tabletAndUp: `(min-width: ${BREAKPOINTS.mobile + 1}px)`,
  tabletAndDown: `(max-width: ${BREAKPOINTS.tablet}px)`,
  desktopAndUp: `(min-width: ${BREAKPOINTS.tablet + 1}px)`
}

/**
 * 根据当前窗口宽度返回屏幕类型
 * @param {number} [width] - 可选，默认使用 window.innerWidth
 * @returns {'mobile'|'tablet'|'desktop'|'wide'}
 */
export function getScreenType(width) {
  const w = width ?? window.innerWidth
  if (w <= BREAKPOINTS.mobile) return 'mobile'
  if (w <= BREAKPOINTS.tablet) return 'tablet'
  if (w <= BREAKPOINTS.desktop) return 'desktop'
  return 'wide'
}
